if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [];
        this.currentIndex = 0;
        this.indicatorsContainer = null;
        this.isMobile = false;
        this.carouselContainer = null;
        this.originalViewport = null;
        this.zoomData = new WeakMap();
        this.activeZoomImg = null;
        this.lastTapTime = 0;

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.blockGesture = this.blockGesture.bind(this);
        this.onBackgroundTap = this.onBackgroundTap.bind(this);
      }

      show(opener) {
        super.show(opener);
        this.isMobile = window.innerWidth < 750;

        if (this.isMobile) {
          this.disableNativeZoom();
          document.body.classList.add('lightbox-activo');
          this.setupCarousel();
          this.setupBackgroundClose();
        }

        this.showActiveMedia();
      }

      hide() {
        if (this.isMobile) {
          this.enableNativeZoom();
          document.body.classList.remove('lightbox-activo');
        }

        this.destroyZoom();
        this.removeIndicators();
        this.cleanupCarousel();

        super.hide();
      }

      disableNativeZoom() {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          this.originalViewport = viewport.getAttribute('content');
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
        }
        document.addEventListener('gesturestart', this.blockGesture, { passive: false });
        document.addEventListener('gesturechange', this.blockGesture, { passive: false });
        document.addEventListener('gestureend', this.blockGesture, { passive: false });
      }

      enableNativeZoom() {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport && this.originalViewport) {
          viewport.setAttribute('content', this.originalViewport);
          this.originalViewport = null;
        }
        document.removeEventListener('gesturestart', this.blockGesture);
        document.removeEventListener('gesturechange', this.blockGesture);
        document.removeEventListener('gestureend', this.blockGesture);
      }

      blockGesture(e) {
        e.preventDefault();
      }

      setupBackgroundClose() {
        if (!this.carouselContainer) return;
        this.carouselContainer.addEventListener('click', this.onBackgroundTap);
      }

      onBackgroundTap(e) {
        const target = e.target;
        if (target.tagName === 'IMG' ||
          target.closest('img') ||
          target.closest('video') ||
          target.closest('model-viewer') ||
          target.closest('deferred-media') ||
          target.closest('.lightbox-indicadores')) {
          return;
        }
        this.hide();
      }

      setupCarousel() {
        const container = this.querySelector('.product-media-modal__content');
        if (!container) return;

        container.classList.add('lightbox-carrusel');
        this.carouselContainer = container;

        this.mediaItems = Array.from(container.querySelectorAll('[data-media-id]'));

        this.mediaItems.forEach(item => {
          item.classList.add('lightbox-carrusel__item');
        });

        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        this.currentIndex = this.mediaItems.findIndex(
          item => item.getAttribute('data-media-id') === openedMediaId
        );
        if (this.currentIndex < 0) this.currentIndex = 0;

        if (this.mediaItems.length > 1) {
          this.createIndicators();
          this.setupScrollListener();
        }

        requestAnimationFrame(() => {
          setTimeout(() => this.initZoom(), 100);
        });
      }

      cleanupCarousel() {
        if (this.carouselContainer) {
          this.carouselContainer.classList.remove('lightbox-carrusel', 'lightbox-carrusel--bloqueado');
          this.carouselContainer.removeEventListener('click', this.onBackgroundTap);
        }
        this.mediaItems.forEach(item => {
          item.classList.remove('lightbox-carrusel__item');
        });
        this.mediaItems = [];
        this.carouselContainer = null;
      }

      createIndicators() {
        this.removeIndicators();
        this.indicatorsContainer = document.createElement('div');
        this.indicatorsContainer.className = 'lightbox-indicadores';

        this.mediaItems.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.className = 'lightbox-indicador' + (i === this.currentIndex ? ' lightbox-indicador--activo' : '');
          dot.addEventListener('click', () => this.goToSlide(i));
          this.indicatorsContainer.appendChild(dot);
        });

        this.appendChild(this.indicatorsContainer);
      }

      removeIndicators() {
        if (this.indicatorsContainer) {
          this.indicatorsContainer.remove();
          this.indicatorsContainer = null;
        }
      }

      updateIndicators() {
        if (!this.indicatorsContainer) return;
        const dots = this.indicatorsContainer.children;
        for (let i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('lightbox-indicador--activo', i === this.currentIndex);
        }
      }

      setupScrollListener() {
        if (!this.carouselContainer) return;
        let scrollTimer;

        this.carouselContainer.addEventListener('scroll', () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => this.onScrollEnd(), 150);
        }, { passive: true });
      }

      onScrollEnd() {
        const newIndex = this.detectCurrentSlide();
        if (newIndex !== this.currentIndex) {
          this.resetZoomForSlide(this.currentIndex);
          this.currentIndex = newIndex;
          this.updateIndicators();
        }
      }

      detectCurrentSlide() {
        if (!this.carouselContainer || this.mediaItems.length === 0) return 0;
        const containerRect = this.carouselContainer.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;

        let closestIndex = 0;
        let closestDistance = Infinity;

        this.mediaItems.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const itemCenter = rect.left + rect.width / 2;
          const distance = Math.abs(containerCenter - itemCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });

        return closestIndex;
      }

      goToSlide(index) {
        if (index < 0) index = this.mediaItems.length - 1;
        if (index >= this.mediaItems.length) index = 0;

        this.resetZoomForSlide(this.currentIndex);
        this.unlockCarousel();
        this.currentIndex = index;

        const targetItem = this.mediaItems[index];
        if (targetItem) {
          targetItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
        this.updateIndicators();
      }

      lockCarousel() {
        if (this.carouselContainer) {
          this.carouselContainer.classList.add('lightbox-carrusel--bloqueado');
        }
      }

      unlockCarousel() {
        if (this.carouselContainer) {
          this.carouselContainer.classList.remove('lightbox-carrusel--bloqueado');
        }
      }

      getImageFromItem(item) {
        if (item.tagName === 'IMG') return item;
        return item.querySelector('img');
      }

      initZoom() {
        this.mediaItems.forEach((item, index) => {
          const img = this.getImageFromItem(item);
          if (!img) return;

          const data = {
            scale: 1,
            x: 0,
            y: 0,
            startScale: 1,
            startX: 0,
            startY: 0,
            startDistance: 0,
            isPinching: false,
            isPanning: false,
            index: index
          };

          this.zoomData.set(img, data);

          img.addEventListener('touchstart', this.onTouchStart, { passive: false });
          img.addEventListener('touchmove', this.onTouchMove, { passive: false });
          img.addEventListener('touchend', this.onTouchEnd, { passive: false });
          img.addEventListener('touchcancel', this.onTouchEnd, { passive: false });
        });
      }

      onTouchStart(e) {
        const img = e.currentTarget;
        const data = this.zoomData.get(img);
        if (!data) return;

        const touches = e.touches;

        if (touches.length === 2) {
          e.preventDefault();
          e.stopPropagation();

          data.isPinching = true;
          data.startScale = data.scale;
          data.startDistance = this.getDistance(touches[0], touches[1]);
          data.startX = data.x;
          data.startY = data.y;

          this.lockCarousel();
          this.activeZoomImg = img;
        } else if (touches.length === 1) {
          const now = Date.now();
          const timeDiff = now - this.lastTapTime;

          if (timeDiff < 300 && timeDiff > 0) {
            e.preventDefault();
            this.handleDoubleTap(img, data, touches[0]);
            this.lastTapTime = 0;
          } else {
            this.lastTapTime = now;
            if (data.scale > 1) {
              e.preventDefault();
              data.isPanning = true;
              data.startX = data.x;
              data.startY = data.y;
              data.panStartX = touches[0].clientX;
              data.panStartY = touches[0].clientY;
              this.activeZoomImg = img;
            }
          }
        }
      }

      onTouchMove(e) {
        const img = e.currentTarget;
        const data = this.zoomData.get(img);
        if (!data) return;

        const touches = e.touches;

        if (data.isPinching && touches.length === 2) {
          e.preventDefault();
          e.stopPropagation();

          const currentDistance = this.getDistance(touches[0], touches[1]);
          const scaleRatio = currentDistance / data.startDistance;
          let newScale = data.startScale * scaleRatio;
          newScale = Math.max(1, Math.min(4, newScale));

          data.scale = newScale;
          this.applyTransform(img, data);
        } else if (data.isPanning && touches.length === 1 && data.scale > 1) {
          e.preventDefault();
          const deltaX = touches[0].clientX - data.panStartX;
          const deltaY = touches[0].clientY - data.panStartY;
          data.x = data.startX + deltaX;
          data.y = data.startY + deltaY;
          this.constrainPan(img, data);
          this.applyTransform(img, data);
        }
      }

      onTouchEnd(e) {
        const img = e.currentTarget;
        const data = this.zoomData.get(img);
        if (!data) return;

        if (data.isPinching) {
          data.isPinching = false;
          if (data.scale < 1.1) {
            this.resetZoom(img, data);
          } else {
            this.constrainPan(img, data);
            this.applyTransform(img, data, true);
          }
        }

        if (data.isPanning) {
          data.isPanning = false;
          this.constrainPan(img, data);
          this.applyTransform(img, data, true);
        }

        if (data.scale <= 1) {
          this.unlockCarousel();
          this.activeZoomImg = null;
        }
      }

      handleDoubleTap(img, data, touch) {
        if (data.scale > 1) {
          this.resetZoom(img, data);
        } else {
          const rect = img.getBoundingClientRect();
          const offsetX = touch.clientX - rect.left - rect.width / 2;
          const offsetY = touch.clientY - rect.top - rect.height / 2;

          data.scale = 2.5;
          data.x = -offsetX * 1.5;
          data.y = -offsetY * 1.5;

          this.constrainPan(img, data);
          this.applyTransform(img, data, true);
          this.lockCarousel();
          img.classList.add('lightbox-imagen--zoomed');
          this.activeZoomImg = img;
        }
      }

      getDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      applyTransform(img, data, animate = false) {
        img.style.transition = animate ? 'transform 0.25s ease-out' : 'none';
        if (data.scale <= 1) {
          img.style.transform = '';
          img.classList.remove('lightbox-imagen--zoomed');
        } else {
          img.style.transform = `translate3d(${data.x}px, ${data.y}px, 0) scale(${data.scale})`;
          img.classList.add('lightbox-imagen--zoomed');
        }
      }

      constrainPan(img, data) {
        if (data.scale <= 1) {
          data.x = 0;
          data.y = 0;
          return;
        }

        const rect = img.getBoundingClientRect();
        const imgW = rect.width / data.scale;
        const imgH = rect.height / data.scale;
        const maxX = (imgW * (data.scale - 1)) / 2;
        const maxY = (imgH * (data.scale - 1)) / 2;

        data.x = Math.max(-maxX, Math.min(maxX, data.x));
        data.y = Math.max(-maxY, Math.min(maxY, data.y));
      }

      resetZoom(img, data) {
        data.scale = 1;
        data.x = 0;
        data.y = 0;
        this.applyTransform(img, data, true);
        this.unlockCarousel();
        this.activeZoomImg = null;
      }

      resetZoomForSlide(index) {
        const item = this.mediaItems[index];
        if (!item) return;
        const img = this.getImageFromItem(item);
        if (!img) return;
        const data = this.zoomData.get(img);
        if (data) {
          this.resetZoom(img, data);
        }
      }

      destroyZoom() {
        this.mediaItems.forEach(item => {
          const img = this.getImageFromItem(item);
          if (!img) return;

          img.removeEventListener('touchstart', this.onTouchStart);
          img.removeEventListener('touchmove', this.onTouchMove);
          img.removeEventListener('touchend', this.onTouchEnd);
          img.removeEventListener('touchcancel', this.onTouchEnd);

          img.style.transform = '';
          img.style.transition = '';
          img.classList.remove('lightbox-imagen--zoomed');
        });
        this.zoomData = new WeakMap();
        this.activeZoomImg = null;
      }

      showActiveMedia() {
        this.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('active'));

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        if (!activeMedia) return;
        activeMedia.classList.add('active');

        if (this.isMobile && this.carouselContainer) {
          requestAnimationFrame(() => {
            activeMedia.scrollIntoView({ behavior: 'instant', inline: 'center', block: 'nearest' });
          });
        } else {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }

        const tpl = activeMedia.querySelector('template');
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && tpl?.content?.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
    }
  );
}